<template>
  <div>
	<div class="toggleHeader">
    	<ToggleServiceProduct @type-changed="selectType" />		
	</div>
    <div class="wrapper">
      <template v-if="isProductShow">
        <nav class="main-nav">
          <h3>{{ $tc('category', 2) }}</h3>
          <div
            class="addBtnWrapper"
            v-on:click="allowToAdd('product-categories-create')"
          >
            <div class="addIcon">
              <font-awesome-icon class="icon" icon="plus" />
              <font-awesome-icon class="iconBig" icon="clipboard-list" />
            </div>
          </div>
          <br />
          <ProductCategoryCard
            v-for="productCategory in productCategory.productCategories"
            :key="productCategory.id"
            :productCategory="productCategory"
            :route="'productCategory'"
          />
        </nav>
        <article class="contentProducts">
          <!-- <h1>{{ $tc('product', 2) }}</h1> -->
          <div class="addBtnWrapper1" v-on:click="allowToAdd('product-create')">
            <div class="addIcon">
				<font-awesome-icon class="icon" icon="plus" />
				<font-awesome-icon class="iconBig" icon="tag" />
            </div>
			<span>{{ $t('addNewProduct') }}</span>
          </div>
          <div class="product-list">
      			<SearchFilter v-if="!(isSearchResult === false && product.products.length === 0)" />
				<div v-if="isSearchResult === true && product.products.length === 0">
					{{ $t('noSearchResult') }}
				</div>
            <div v-else-if="product.products.length === 0" class="productsEmpty">
              <figure class="about-img2 img-wrapper">
                <img src="../assets/static/images/illustrations/product.svg" />
              </figure>
              <!-- <router-link :to="'/' + 'products/create/' + $i18n.locale"><p> -->
              <!-- <button class="add-btn" @click="allowToAdd('product-create')">{{ $t('addFirstProduct') }}</button> -->
              <!-- </p></router-link>               -->
            </div>

            <div v-else class="productsEntered">
              <!-- <PulseIcon v-on:click.native="allowToAdd();" /> -->
              <transition-group
                class="product-cards column"
                name="slide-up"
                tag="ul"
                appear
              >
                <ProductCard
                  v-for="product in product.products"
                  :key="product.id"
                  :product="product"
                  :route="'product'"
                />
              </transition-group>
            </div>
          </div>
        </article>
      </template>
      <template v-else>
        <!-- <nav class="main-nav">
          <h3>{{ $tc('category', 2) }}</h3>
          <div
            class="addBtnWrapper"
            v-on:click="allowToAdd('experience-categories-create')"
          >
            <div class="addIcon">
              <font-awesome-icon class="icon" icon="plus" />
              <font-awesome-icon class="iconBig" icon="clipboard-list" />
            </div>
          </div>
          <br />
          <ProductCategoryCard
            v-for="experienceCategory in experience.experienceCategories"
            :key="experienceCategory.id"
            :productCategory="experienceCategory"
            :route="'experienceCategory'"
            :experience="true"
            class="card-columns"
          />
        </nav> -->

        <article class="contentProducts">
          <!-- <h1>{{ $tc('experienceLabel', 2) }}</h1> -->
          <!-- <div
            class="addBtnWrapper1"
            v-on:click="allowToAdd('experience-create')"
          >
            <div class="addIcon">
              <font-awesome-icon class="icon" icon="plus" />
              <font-awesome-icon class="iconBig" icon="tag" />
            </div>
          </div> -->
          <div class="product-list">
            <SearchFilter v-if="!(isSearchResult === false && experience.experiences.length === 0)" />	
            <div v-if="isSearchResult === true && experience.experiences.length === 0">	
              {{ $t('noSearchResult') }}	
            </div>
            <div
              v-if="experience.experiences.length === 0"
              class="productsEmpty"
            >
              <figure class="about-img2 img-wrapper">
                <img src="../assets/static/images/illustrations/product.svg" />
              </figure>
              <!-- <router-link :to="'/' + 'products/create/' + $i18n.locale"><p> -->
              <!-- <button class="add-btn" @click="allowToAdd('product-create')">{{ $t('addFirstProduct') }}</button> -->
              <!-- </p></router-link>               -->
            </div>

            <div v-else class="productsEntered">
              <!-- <PulseIcon v-on:click.native="allowToAdd();" /> -->
              <transition-group
                class="column"
                name="slide-up"
                tag="ul"
                appear
              >
                <ExperienceCard
                  v-for="experience in experience.experiences"
                  :key="experience.id"
                  :experience="experience"
                  @refresh-experience-list="refreshExperienceList"
                />
              </transition-group>
            </div>
          </div>
        </article>
      </template>
      <aside class="side">
		<h3>{{ $t('featuredProduct') }}</h3>
		<FeaturedProductCard></FeaturedProductCard>
        <!-- <h3>{{ $tc('supplier', 2) }}</h3>
        <div class="addBtnWrapper" v-on:click="allowToAdd('supplier-create')">
          <div class="addIcon">
            <font-awesome-icon class="icon" icon="plus" />
            <font-awesome-icon class="iconBig" icon="truck" />
          </div>
        </div>
        <br />
        <SupplierCard
          v-for="supplier in supplier.suppliers"
          :key="supplier.id"
          :supplier="supplier"
          class="card-columns"
        />
        <br /> -->
      </aside>
      <!-- <div>
        <button v-if="isProductShow" class="product-list-btn" @click="redirectToProductListPage()">{{ $tc('GoToProductList') }}</button>
      </div> -->

      <div class="ad">
        <!-- Advertising -->
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '@/components/ui/ProductCard.vue'
import ExperienceCard from '@/components/ui/ExperienceCard.vue'
import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'
import FeaturedProductCard from '@/components/ui/FeaturedProductCard.vue'
import SearchFilter from '@/components/common/SearchFilter.vue'
// import SupplierCard from '@/components/ui/SupplierCard.vue'
// import PulseIcon from '@/components/common/PulseIcon.vue'
import { mapState } from 'vuex'
import ToggleServiceProduct from '@/components/common/ToggleServiceProduct.vue'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('prodCatalogue'),
    }
  },
  components: {
    ProductCard,
    ExperienceCard,
    ProductCategoryCard,
	FeaturedProductCard,
  	SearchFilter,
    // SupplierCard
    ToggleServiceProduct,
    // PulseIcon
  },
  data() {
    return {
      isProductShow: true,
      isSearchResult: false
    }
  },
  async mounted() {
    this.isSearchResult = false
  },
  created() {
    this.$store.dispatch('product/fetchProducts')
    this.$store.dispatch('productCategory/fetchProductCategories')
    this.$store.dispatch('supplier/fetchSuppliers')
    this.$store.dispatch('experience/fetchExperienceCategories')
    this.$store.dispatch('experience/fetchExperiences')
  },
  methods: {
    selectType(value) {
      this.isProductShow = value
    },
    allowToAdd(path) {
      this.$store.dispatch('client/profileCompleteness').then((response) => {
        if (response && response.profile_complete === true) {
          this.$router.push({ name: path, params: { lang: this.$i18n.locale } })
        } else {
          alert(this.$t('completeProfileFirst'))
        }
      })
    },
    redirectToProductListPage() {
      const user = localStorage.getItem('user')
      let routeData = this.$router.resolve({
        name: 'productList',
        params: { clientId: JSON.parse(user).id },
      })
      window.open(routeData.href, '_blank')
    },
    async searchTerm(search) {
      if (this.isProductShow) await this.$store.dispatch('product/searchProducts', search)
      else await this.$store.dispatch('experience/searchExperiences', search)
      this.isSearchResult = true
    },
    clearSearch() {
      if (this.isProductShow) this.$store.dispatch('product/fetchProducts')
      else this.$store.dispatch('experience/fetchExperiences')
      this.isSearchResult = false
    },
    refreshExperienceList() {
      this.$store.dispatch('experience/fetchExperiences')
    }
  },
  computed: mapState([
    'product',
    'productCategory',
    'supplier',
    'client',
    'experience',
  ]),
}
</script>

<style  lang="scss" scoped>
.productsEmpty {
  // display: none; //! none when NO product with this client_id is found in db //
}
.productsEntered {
  // display: none; //! none when NO product with this client_id is found in db //
}

h3 {
  margin-top: 10px;
}
//CSS Grid Layout//@
.contentProducts {
  grid-area: content;
  background-color: var(--bright);
  margin-top: 100px;
  height: 100%;
  width: auto;
}
.toggleHeader {
  grid-area: header;
  background-color: var(--bg-superLight);;
//   height: auto;
  padding: 3px;
}
.main-nav {
  grid-area: nav;
  background-color: lightgrey;
  height: 100%;
  margin-top: 100px;
}
.side {
  grid-area: sidebar;
  background-color: lightgrey;
  height: 100%;
  margin-top: 100px;
}
.ad {
  grid-area: ad;
  background-color: lightgrey;
}
.wrapper {
  display: grid;
  gap: 2px;
  grid-template-areas:
	'header'
    'nav'
    'content'
    'sidebar'
    'ad';
  height: 100vh;
  margin-top: -100px;
}
// add button CSS sytling//
.addBtnWrapper {
  background-color: var(--bright);
  color: var(--bg);
  width: 30%;
  padding: 10px;
  margin: auto;
  border-radius: 10px;
}
.addBtnWrapper:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--primaryDark);
  color: var(--bright);
  transition: 0.25s box-shadow, 0.25s transform;
}
.addBtnWrapper:hover {
  background-color: var(--primaryDark);
  color: var(--bright);
}
.addBtnWrapper1 {
  background-color: var(--primaryDark);
  color: var(--bright);
  width: 120px;
  padding: 10px;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
}
.addBtnWrapper1:active {
  transform: translateY(5px);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  background-color: var(--bright);
  color: var(--bg);
  transition: 0.25s box-shadow, 0.25s transform;
}

.addIcon {
	cursor: pointer;
}

// .addBtnWrapper1:hover {
//   background-color: var(--bright);
//   color: var(--bg);
// }
.iconBig {
  font-size: 1.4rem;
}
// end of add btn//

@media (min-width: 500px) {
  .wrapper {
    grid-template-columns: 1fr 3fr;
    grid-template-areas:
		'header header'
		'nav     nav'
		'content content'
		'sidebar      sidebar'
  }
  // nav ul {
  //   display: flex;
  //   justify-content: space-between;
  // }
}
@media (min-width: 1100px) {
  .wrapper {
    grid-template-columns: 2fr 6fr 1fr;
    grid-template-rows: auto;
    grid-template-areas:
		'header header header'
		'nav    content sidebar'
  }
  .product-category-card {
	min-width: 200px;
}
  nav ul {
    flex-direction: column;
  }
}

@media only screen and (min-device-width: 360px) and (max-device-width: 780px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .wrapper {
    grid-template-columns: 2fr 4fr 1fr;
    grid-template-rows: 1fr auto;
    grid-template-areas:
      'nav    content sidebar'
      'nav    content sidebar';
  }
  .product-category-card {
    width: 90%;
	margin: auto;
}
.main-nav {
	height: 200vh;
}
}
//END OF CSS Grid Layout //

.add-btn {
	background: var(--primaryDark);
	color: var(--bright);
	padding: 1em;
	border-radius: 5px;
	letter-spacing: 3px;
	width: 30%;
}

.product-list-btn {
  background: var(--primaryDark);
  color: var(--bright);
  padding: 1em;
  letter-spacing: 3px;
  align-self: center;
  width: 100%;
}

.about-img2 {
  display: inline-block;
  width: 80%;
  max-width: 350px;
  text-align: center;
  vertical-align: top;
}
.column {
    display: flex;
    flex-flow: wrap;
    height: 100%;
	justify-content: center;
  }
.product-list {
  margin-top: 10px;
}
.product-cards {
  margin-top: 20px;
  margin-left: 0;
  padding-left: 0px;
}

@media screen and (max-width: 780px) {
  .add-btn {
    width: 80%;
  }
  .product-card {
    width: 80%;
  }
  .toggleHeader {
    margin-top: -20px;
  }
}

@media screen and (min-width: 2200px) {
	.contentProducts {
  margin-top: 25px;
}
.main-nav {
  margin-top: 25px;
}
.side {
  margin-top: 25px;
}
}

@media screen and (max-width: 500px) {
  .wrapper {
    margin-top: 0 !important;
  }
  .contentProducts {
    margin-top: 0 !important;
  }
  .main-nav {
    margin-top: 0;
    margin-bottom: 15px;
  }
  .side {
    margin-top: 0;
  }
  .column {
	padding: 0 !important;
  }
.addBtnWrapper1 {
	margin: 30px auto;
  }
  .product-category-card {
	margin: auto;
}
}

@media screen and (min-width: 500px) and (max-width: 800px) {
.product-category-card {
    width: 90%;
	margin:auto;
}
.card-title {
    width: auto;
}
}

</style>
